import { Fragment } from 'react';
import { DISEASE_VOCABULARY_LINKS as vocabulariesLinks } from '../Table/columns/config/constants';

function Filas({ resultado, lista, type = 'Disease' }) {
  let i = 0;
  return (
    <Fragment key={`${resultado}${type}${i}`}>
      {resultado === 'UMLS'
        ? null
        : lista.map((value, index) => {
            let link;
            if (type === 'Disease') {
              const cleanedUpValueCode = value.code.replaceAll('.', '');
              link = `${vocabulariesLinks[resultado]}${cleanedUpValueCode}`;
            }
            if (resultado !== value.vocabulary) return null;

            i++;

            return (
              <tr
                key={`${resultado}-${value.vocabulary}-${value.code}-${index}`}
                className={i !== 1 ? 'FilaSinBorde' : null}
              >
                {i === 1 ? <td className="text-xs font-semibold">{resultado}:</td> : <td />}
                <td className="text-xs font-semibold">
                  {type === 'Disease' ? (
                    <a href={link} className="mapId" target="_blank" rel="noreferrer">
                      {value.code}
                    </a>
                  ) : (
                    <span className="text-xs text-semibold">{value.code}</span>
                  )}
                </td>
                <td className="text-xs">
                  <span className="text-xs">{value.name}</span>
                </td>
              </tr>
            );
          })}
    </Fragment>
  );
}

export default Filas;
